import { api } from '../api/client'
import { openInNewTab } from '../ui/newTab'

// openPortal opens Stripe's billing portal in a new tab.
export function openPortal(): Promise<void> {
  return openInNewTab(() => api.portalUrl())
}
